import React from "react";

const PrivacyPolicy = () => {
  return (
    <div style={{background:"#000"}}  className="p-6 max-w-4xl mx-auto">
      <h1 className="text-2xl font-bold mb-4">Privacy Policy</h1>
      <p>
        At PlayGG, we value your privacy and are committed to protecting your
        personal information. This Privacy Policy explains how we collect, use,
        and protect your data when you use our website, mobile app, and
        services (collectively referred to as the "Platform").
      </p>
      <p>
        By accessing or using our Platform, you consent to the practices
        described in this Privacy Policy.
      </p>

      <h2 className="text-xl font-semibold mt-6">1. Information We Collect</h2>
      <h3 className="font-semibold mt-4">1.1 Personal Information</h3>
      <p>
        When you register, participate in activities, or contact us, we may
        collect:
      </p>
      <ul className="list-disc pl-6">
        <li>Name, email address, phone number, and other account details.</li>
        <li>Payment information (if applicable) for transactions.</li>
      </ul>

      <h3 className="font-semibold mt-4">1.2 Non-Personal Information</h3>
      <p>We may collect technical data, such as:</p>
      <ul className="list-disc pl-6">
        <li>IP address, browser type, operating system, and device details.</li>
        <li>Usage data, including pages visited, time spent on the Platform, and actions taken.</li>
      </ul>

      <h3 className="font-semibold mt-4">1.3 Cookies and Tracking Technologies</h3>
      <p>
        We use cookies and similar technologies to enhance user experience,
        analyze trends, and improve our services. You can manage cookie
        preferences through your browser settings.
      </p>

      <h2 className="text-xl font-semibold mt-6">2. How We Use Your Information</h2>
      <p>We use your information to:</p>
      <ul className="list-disc pl-6">
        <li>Provide and maintain our services.</li>
        <li>Facilitate tournaments, bookings, and other activities.</li>
        <li>Communicate updates, promotional offers, and service-related announcements.</li>
        <li>Analyze usage to improve our Platform and develop new features.</li>
        <li>Prevent fraud, security breaches, and unauthorized access.</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6">3. Sharing Your Information</h2>
      <p>We do not sell or rent your personal information. However, we may share your data in the following cases:</p>
      <ul className="list-disc pl-6">
        <li>With service providers: For payment processing, hosting, analytics, or customer support.</li>
        <li>For legal compliance: When required by law or to protect our rights.</li>
        <li>With your consent: If you agree to share your information with third parties.</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6">4. Data Retention</h2>
      <p>
        We retain your information as long as it is necessary to fulfill the
        purposes outlined in this policy or as required by law.
      </p>

      <h2 className="text-xl font-semibold mt-6">5. Your Rights</h2>
      <p>You have the right to:</p>
      <ul className="list-disc pl-6">
        <li>Access, update, or delete your personal information.</li>
        <li>Opt-out of marketing communications.</li>
        <li>Withdraw consent for data collection (where applicable).</li>
      </ul>
      <p>To exercise these rights, contact us at contact@getweplay.in</p>

      <h2 className="text-xl font-semibold mt-6">6. Security Measures</h2>
      <p>
        We implement appropriate technical and organizational measures to
        protect your data. However, no method of transmission over the internet
        is 100% secure, and we cannot guarantee absolute security.
      </p>

      <h2 className="text-xl font-semibold mt-6">7. Third-Party Links</h2>
      <p>
        Our Platform may contain links to third-party websites or services. We
        are not responsible for the privacy practices of these external sites.
      </p>

      <h2 className="text-xl font-semibold mt-6">8. Children's Privacy</h2>
      <p>
        Our Platform is not intended for children under 13 years of age. We do
        not knowingly collect personal information from children.
      </p>

      <h2 className="text-xl font-semibold mt-6">9. Changes to This Privacy Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. Significant
        changes will be communicated through our Platform or other means.
      </p>

      <h2 className="text-xl font-semibold mt-6">10. Contact Us</h2>
      <p>
        If you have any questions or concerns about this Privacy Policy, please
        reach out to us at:
      </p>
      <p className="font-semibold">Email: contact@getweplay.in</p>

      <p className="mt-6">
        By using our Platform, you acknowledge that you have read and
        understood this Privacy Policy.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
